<template>
  <article>
    <NavigationTop name="Medioze" link="/" />

    <section class="layout-section -space-top">
      <MediozeHeader />
      <MediozeGallery />
    </section>
  </article>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ProjectMedioze',
  components: { ...partials },
}
</script>
